import styled from 'styled-components';

export default styled.span`
  display: block;
  flex: 1 1 0;
`;
